import { useEffect, useState } from "react";
import { UserRound, FileQuestion, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { usePricing, bookingHref } from "../lib/catalog";
import site from "../content/site.json";
import CtaLink, { btnPrimary } from "./CtaLink";

export function FounderSection() {
  const { data } = usePricing();
  const f = site.founder;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="founder-section">
      <div className="rounded-3xl border border-slate-200 bg-white p-8 sm:p-10 grid md:grid-cols-[180px_1fr] gap-8 items-center">
        <div className="h-40 w-40 rounded-2xl bg-slate-100 border border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400" data-testid="founder-photo-placeholder">
          <UserRound className="h-10 w-10" />
          <span className="text-[11px] mt-2 font-mono uppercase">Photo coming soon</span>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-indigo-600">Who you'll work with</p>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-2" data-testid="founder-name">{f.name}</h2>
          <p className="text-slate-500 font-medium">{f.title}</p>
          <p className="mt-4 text-slate-600 max-w-2xl" data-testid="founder-bio">{f.bio}</p>
          <CtaLink to={bookingHref(data?.booking?.strategy_call_url)} className={`${btnPrimary} mt-6`} testid="founder-book-call">{f.cta} <ArrowRight className="h-4 w-4 ml-2" /></CtaLink>
        </div>
      </div>
    </section>
  );
}

function SelfCaseStudy() {
  const [cs, setCs] = useState(null);
  useEffect(() => { api.get("/public/case-study").then(({ data }) => setCs(data)).catch(() => setCs({})); }, []);
  const b = cs?.before, a = cs?.after;
  return (
    <div className="rounded-2xl border-2 border-indigo-200 bg-white p-6 flex flex-col" data-testid="case-study-self">
      <p className="font-mono text-[11px] uppercase tracking-widest text-indigo-600">Case study #1</p>
      <h3 className="font-heading font-bold text-slate-900 mt-1">Our own site: before vs after</h3>
      <p className="text-sm text-slate-500 mt-1">We ran our own AI Revenue Readiness Score™ on makemybusinessaiready.com before and after making it AI-readable.</p>
      <div className="grid grid-cols-2 gap-3 mt-5">
        {[["Before", b], ["After", a]].map(([label, s]) => (
          <div key={label} className="rounded-xl bg-slate-50 border border-slate-200 p-4 text-center" data-testid={`case-study-${label.toLowerCase()}`}>
            <p className="text-xs text-slate-500">{label}</p>
            <p className="font-heading text-3xl font-bold text-slate-900 mt-1">{s ? s.score : "—"}</p>
            <p className="text-[11px] text-slate-400 mt-1">{s ? new Date(s.scanned_at).toLocaleDateString() : label === "After" ? "Measured after launch" : "Pending"}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ProofSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="proof-section">
      <p className="font-mono text-xs uppercase tracking-widest text-indigo-600 mb-3">Proof</p>
      <h2 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Real results only. No made-up case studies.</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
        <SelfCaseStudy />
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-2xl border border-dashed border-slate-300 bg-slate-50/60 p-6 flex flex-col items-center justify-center text-center min-h-[220px]" data-testid={`case-study-slot-${i}`}>
            <FileQuestion className="h-7 w-7 text-slate-300" />
            <p className="font-heading font-semibold text-slate-500 mt-3">Founding client case study — coming soon</p>
          </div>
        ))}
      </div>
    </section>
  );
}
